import { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../config/api';

const useRegister = () => {
  // 🧩 State for all required fields
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // ✅ Email validation
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // ✅ Phone validation (simple check)
  const validatePhone = (phone) => /^\+?\d{7,15}$/.test(phone);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Generate username from firstname and lastname
  const username = `${firstname.toLowerCase()}_${lastname.toLowerCase()}`;

    // 🧠 Frontend validations
    if (!firstname || !lastname || !phone || !email || !password) {
      setError('All fields are required.');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    if (!validatePhone(phone)) {
      setError('Please enter a valid phone number.');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    // Clear previous messages
    setError('');
    setSuccess('');

    try {
      // ✅ Send to your backend route.
      // Use centralized BASE_URL
      const formattedBaseURL = BASE_URL.replace(/\/+$/, '') + '/';

      const response = await axios.post(`${formattedBaseURL}auth/register`, {
        firstname,
        lastname,
        phone,
        email,
        password,
        username,
      });

      console.log('Registration successful:', response.data);
      setSuccess('Registered successfully!');
      setFirstname('');
      setLastname('');
      setPhone('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      console.error('Registration failed:', err);
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    }
  };

  return {
    firstname,
    setFirstname,
    lastname,
    setLastname,
    phone,
    setPhone,
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    error,
    success,
    setError,
    setSuccess,
    showPassword,
    setShowPassword,
    handleSubmit,
  };
};

export default useRegister;
